var axios = require('axios');

const ZENDESK_API_URL = 'https://ndrip.zendesk.com/api/v2/requests.json';

/**
 * Human-readable label for where a support request originated. Rendered in the
 * ticket footer ("Submitted from: ...") and sent to the backend as `source`.
 * Shared by both support paths — the anonymous one below and the authenticated
 * one in zendeskSupportApi — so the value lives in exactly one place.
 */
export const SupportSource = Object.freeze({
  WEB: 'Web App',
  MOBILE: 'Mobile App',
});

/**
 * Anonymous support submission via the Zendesk public requests API.
 *
 * Used only for unauthenticated users. Because the request is anonymous,
 * Zendesk sends the requester an email verification link before the ticket
 * becomes active. Authenticated users go through the backend agent path
 * instead (sendSupportViaApi), which does not require verification.
 *
 * The comment body mirrors the backend format exactly (message followed by a
 * "Submitted from" footer, ticket title derived from the first line), so
 * anonymous and authenticated tickets look identical.
 */
export const sendMessage = async (userName, userEmail, body, options = {}) => {
  const source =
    options.source ||
    (options.platform === 'web' ? SupportSource.WEB : SupportSource.MOBILE);
  const commentBody = `${body}\n\n------------------\nSubmitted from: ${source}`;

  // The public requests API requires a non-blank subject, whereas the agent
  // tickets API used by authenticated users derives the title from the first
  // line of the comment. Pass the first line explicitly so both paths produce
  // the same ticket title.
  const subject = (body || '').trim().split('\n')[0] || 'Support request';

  const payload = {
    request: {
      subject: subject,
      requester: {
        name: userName || userEmail || 'Anonymous',
        email: userEmail,
      },
      comment: { body: commentBody },
    },
  };

  const res = await axios.post(ZENDESK_API_URL, payload, {
    headers: { 'Content-Type': 'application/json' },
  });

  if (options.returnFullResponse) {
    return res;
  }
  return res.status >= 200 && res.status < 300;
};
